"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Avatar = require("./Avatar.style");

var _AvatarImage = _interopRequireDefault(require("../AvatarImage"));

var Avatar = function Avatar(_ref) {
  var company = _ref.company,
      image = _ref.image,
      jobTitle = _ref.jobTitle,
      name = _ref.name,
      rectangular = _ref.rectangular;
  return /*#__PURE__*/_react.default.createElement(_Avatar.AvatarContainer, null, /*#__PURE__*/_react.default.createElement(_AvatarImage.default, {
    image: image,
    name: name,
    rectangular: rectangular
  }), /*#__PURE__*/_react.default.createElement(_Avatar.AvatarContent, null, name && /*#__PURE__*/_react.default.createElement(_Avatar.AvatarName, null, name), jobTitle && /*#__PURE__*/_react.default.createElement(_Avatar.AvatarText, null, jobTitle), company && /*#__PURE__*/_react.default.createElement(_Avatar.AvatarTextSmall, null, company)));
};

Avatar.propTypes = {
  company: _propTypes.default.string,
  image: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }),
  jobTitle: _propTypes.default.string,
  name: _propTypes.default.string,
  rectangular: _propTypes.default.bool
};
Avatar.defaultProps = {
  company: '',
  image: null,
  jobTitle: '',
  name: '',
  rectangular: false
};
var _default = Avatar;
exports.default = _default;